import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  inputGroup: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

export default useStyles;
